(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5379],{

/***/ 5379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content043": function() { return /* binding */ Content043; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content043_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66521);
/* harmony import */ var _Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content043 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subtitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var image = (ref3 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref3 !== void 0 ? ref3 : {};
    var ref4;
    var ref5 = (ref4 = payload === null || payload === void 0 ? void 0 : payload.button) !== null && ref4 !== void 0 ? ref4 : {}, buttonText = ref5.buttonText, link = ref5.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().preview),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                                image: image,
                                className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().about),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading5 */ .by, {
                                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                    value: description,
                                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().circle),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .PageLink */ .H_, {
                                        link: link,
                                        className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                                    className: (_Content043_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                                                    name: "large_arrow_right"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                                color: "brand",
                                                appearance: "bigger",
                                                children: buttonText
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content043);


/***/ }),

/***/ 66521:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content043_wrapper__UKU_G","content":"Content043_content__eWZdn","title":"Content043_title__kYaUf","subtitle":"Content043_subtitle__NGjAt","about":"Content043_about__cSq0D","description":"Content043_description__xc_qK","preview":"Content043_preview__UjDP8","image":"Content043_image__IIgAC","circle":"Content043_circle__rHoua","link":"Content043_link__KvzYv","arrow":"Content043_arrow__p5s8d","icon":"Content043_icon__OoDu3"};

/***/ })

}]);